// extracted by mini-css-extract-plugin
export default {"container":"SectionScroll_container__o8vla","indicator":"SectionScroll_indicator__EdwMV","progress":"SectionScroll_progress__-3oU8","title":"SectionScroll_title__GqiyU"};